var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDropdownArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.75,
    height: 20.75,
    viewBox: "0 0 20.75 20.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ios-arrow-dropdown",
    transform: "translate(-3.375 -3.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_78",
    "data-name": "Tracciato 78",
    d: "M10.263,14.7a.967.967,0,0,0,0,1.362l4.774,4.759a.962.962,0,0,0,1.327.03l4.7-4.688A.961.961,0,1,0,19.71,14.8l-4.04,3.98-4.045-4.085a.963.963,0,0,0-1.362,0Z",
    transform: "translate(-1.92 -3.208)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_79",
    "data-name": "Tracciato 79",
    d: "M3.375,13.75A10.375,10.375,0,1,0,13.75,3.375,10.373,10.373,0,0,0,3.375,13.75Zm16.58-6.205a8.775,8.775,0,1,1-12.41,12.41,8.775,8.775,0,1,1,12.41-12.41Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDropdownArrow);
export default __webpack_public_path__ + "static/media/icon_dropdown_arrow.21259d9bcc11c990fee2bd6aa762ff81.svg";
export { ForwardRef as ReactComponent };